import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { useCallback, useMemo } from 'react';
import { Box, Button, IconButton, Paper, Popover, Typography, } from '@mui/material';
import { Close } from '@mui/icons-material';
import { useAction, useAppSelector } from 'shared/hooks/redux/hooks';
import branding from 'shared/app/model/branding';
import { createSelector } from '@reduxjs/toolkit';
import { LegacyDevice } from 'console/device/device';
import { Capability } from '../device/device-capability';
import { selectMapDashboardEnabled } from 'pages/dashboard.map/model/selectors';
import { ColorRocketIcon } from '../billing/account-tariff/rocketIcon';
import { closeProPopup } from './redux/action';
import './pro.sass';
import { is_paid_tariff } from '../billing/billing-utils';
import { filterDeviceTreeFromGroup } from '../sortableDeviceTree/utils/device-tree-utils';
import { selectDevices } from 'entities/device/lib';
import { selectDeviceTree } from 'console/redux/devices/tree/selectors';
import { useNavigateTo } from 'shared/hooks/router';
const select_device_for_map_dashboard = createSelector(selectDevices, (devices) => {
    return devices.filter((dev) => !LegacyDevice.has_capability(dev?.capabilities, Capability.has_gps)).length;
});
export function useShowMapDashboard() {
    const device_count = useAppSelector(select_device_for_map_dashboard);
    const map_dashboard_enabled = useAppSelector(selectMapDashboardEnabled);
    //Если в зонте
    if (branding.enable_zont_billing) {
        //Если не автомобильных устройств больше 2, то показываем карту для рекламы
        // if (device_count > 2) {
        //     return true;
        // }
        //Иначе, согласно купленным билетам
        return map_dashboard_enabled;
    }
    return false;
}
/**
 * @function
 * @return device_tree_items
 * Беру дерево групп и чищу его, если кончился тарии
 */
export function useSelectDeviceTree() {
    const device_tree = useAppSelector(selectDeviceTree);
    const _is_paid_tariff = useAppSelector(is_paid_tariff);
    return useMemo(() => {
        //Если в зонте
        if (branding.enable_zont_billing) {
            //Если платный тариф, то возвращаем дерево, как есть
            if (_is_paid_tariff) {
                return device_tree;
            }
            return device_tree.flatMap(filterDeviceTreeFromGroup);
        }
        return device_tree;
    }, [_is_paid_tariff, device_tree]);
}
export function ProContent(props) {
    const { content, text, onClose, maxWidth } = props;
    const openTariff = useNavigateTo('/billing/tariff');
    const openChooser = useCallback(() => {
        if (props.openChooser) {
            props.openChooser();
        }
        else {
            openTariff();
        }
        onClose?.();
    }, [openTariff, onClose]);
    return (_jsxs(Box, { p: 1, py: 2, maxWidth: maxWidth, display: "flex", flexDirection: "row", justifyContent: "center", children: [_jsx(ColorRocketIcon, { sx: {
                    alignSelf: 'center',
                }, style: {
                    width: 75,
                } }), _jsxs(Box, { display: "flex", flexDirection: "column", alignItems: "center", children: [_jsx(Typography, { sx: {
                            textAlign: 'center',
                            color: 'error.main',
                            mb: 1,
                        }, children: text }), content, _jsx(Button, { variant: "contained", color: "primary", onClick: openChooser, children: "\u041F\u0435\u0440\u0435\u0439\u0442\u0438" })] }), onClose != null && (_jsx(IconButton, { onClick: onClose, size: "large", sx: {
                    alignSelf: 'flex-start',
                    mt: -2,
                    mr: -1,
                }, children: _jsx(Close, {}) }))] }));
}
export function ProPopup(props) {
    const { anchorEl, onClose } = props;
    return (_jsx(Popover, { id: "pro-popover", open: Boolean(anchorEl), anchorEl: anchorEl, onClose: onClose, anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'center',
        }, transformOrigin: {
            vertical: 'top',
            horizontal: 'center',
        }, children: _jsx(ProContent, { ...props, maxWidth: 380 }) }));
}
export function ProPaper(props) {
    const { paperProps } = props;
    return (_jsx(Paper, { ...paperProps, children: _jsx(ProContent, { ...props }) }));
}
export function ProPopupRedux() {
    const open = useAppSelector((state) => state.pro_popup.open);
    const text = useAppSelector((state) => state.pro_popup.text);
    const close = useAction(closeProPopup);
    return open ? (_jsx("div", { className: "ProPaper ForPeriod", children: _jsx(ProPaper, { onClose: close, text: text, maxWidth: 380 }) })) : null;
}
